import React, { useEffect, useState } from "react";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import Controls from "../../../../components/form/controls/Controls";
import { Card, CardContent } from "@mui/material";
import { NotifyConfirm } from "../../../../components/notify/Notify";
import IntentScriptForm from "./IntentScriptForm";
import IntentScriptTable from "./IntentScriptTable";

const defaultSlotValue = {
  name: "value",
  type: "string",
};

const renderObjectSlotValue = (listSlot) => {
  const objValue = {};
  for (const slot of listSlot) {
    objValue[slot.name] = "";
  }
  return objValue;
};

const mapSlotNameAndType = (listSlot) => {
  const objValue = {};
  for (const slot of listSlot) {
    objValue[slot.name] = slot;
  }
  return objValue;
};

const formatPropsValue = (object) => {
  const ans = [];
  for (const [key, value] of Object.entries(object)) {
    ans.push({ name: key, value });
  }

  return JSON.stringify(ans);
};

const IntentScriptConfig = ({
  handleCreateIntentScript,
  contextSlots: availableSlotsContext, // danh sách slot hiện tại của context: hay còn gọi là có sẵn (available) = availableSlotsContext
  intentScriptValues: ttsIntentScriptValues,
  applyForIntent,
}) => {
  const [slotMapByName, setSlotMapByName] = useState({});
  const [intentScriptValues, setIntentScriptValues] = useState([]);
  const [availableSlotNames, setAvailableSlotNames] = useState([]);
  const [inputPattern, setInputPattern] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [type, setType] = useState("string");

  useEffect(() => {
    let objectValuePattern = renderObjectSlotValue([
      defaultSlotValue,
      ...availableSlotsContext,
    ]);

    let result = mapSlotNameAndType([...availableSlotsContext]);

    setSlotMapByName({ ...result });
    setIntentScriptValues([...JSON.parse(ttsIntentScriptValues)]);
    setAvailableSlotNames(Object.keys(objectValuePattern));
    setInputPattern({ fakeId: "", ...objectValuePattern });
  }, [availableSlotsContext, ttsIntentScriptValues]);

  const onSubmit = (e) => {
    e.preventDefault();
    handleCreateIntentScript(intentScriptValues);
  };

  const handleScriptValueRemove = (fakeId) => {
    NotifyConfirm("warning", "Are you delete it ?", (result) => {
      if (result.isConfirmed) {
        const newIntentScriptValues = [...intentScriptValues];

        const foundIndexValue = intentScriptValues.findIndex(
          (value) => value.fakeId === fakeId
        );
        if (foundIndexValue !== -1) {
          newIntentScriptValues.splice(foundIndexValue, 1);
          setIntentScriptValues([...newIntentScriptValues]);
          setRecordForEdit(null);
          handleCreateIntentScript(newIntentScriptValues);
        }
      }
    });
  };

  const handleEdit = (intentScriptValue) => {
    const slotMapByNameCopy = { ...slotMapByName };
    for (const [key, slot] of Object.entries(slotMapByNameCopy)) {
      if (slot?.["type"] === "object") {
        const propEdit = intentScriptValue[key];
        slot["props"] = formatPropsValue(propEdit);
      }
    }
    setRecordForEdit({ ...intentScriptValue });
    setInputPattern({ ...intentScriptValue });
    setSlotMapByName({ ...slotMapByNameCopy });
    setType(intentScriptValue?.type);
  };

  return (
    <div
      onSubmit={onSubmit}
      style={{ border: "dashed 1px" }}
      autoComplete="off"
    >
      <div style={{ padding: "20px" }}>
        <div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h5>Template-intent config</h5>
            <Controls.Button
              sx={{
                width: "300px",
                marginTop: "10px",
                marginLeft: "10px",
                padding: "8px",
              }}
              type="button"
              startIcon={<KeyboardDoubleArrowUpIcon sx={{ margin: "0px" }} />}
              text="Apply for main-intent values"
              onClick={() => applyForIntent(intentScriptValues)}
            />
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ width: "50%", padding: "40px" }}>
              <IntentScriptForm
                availableSlotsContext={availableSlotsContext}
                availableSlotNames={availableSlotNames}
                slotMapByName={slotMapByName}
                intentScriptValues={intentScriptValues}
                recordForEdit={recordForEdit}
                setRecordForEdit={setRecordForEdit}
                inputPattern={inputPattern}
                setInputPattern={setInputPattern}
                handleCreateIntentScript={handleCreateIntentScript}
                type={type}
                setType={setType}
              />
            </div>
            <div style={{ width: "50%", padding: "40px" }}>
              <div style={{ marginBottom: "10px" }}>
                <h5>Template-intent values</h5>
              </div>
              <Card>
                <CardContent sx={{ height: "300px", overflow: "auto" }}>
                  <pre>{JSON.stringify(intentScriptValues, null, 2)}</pre>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>

        <IntentScriptTable
          availableSlotNames={availableSlotNames}
          intentScriptValues={intentScriptValues}
          handleEdit={handleEdit}
          handleScriptValueRemove={handleScriptValueRemove}
        />
      </div>
    </div>
  );
};

export default IntentScriptConfig;
